import type { EffectCallback } from "react";
import { useEffect, useRef } from "react";

export function useMountEffect(callback: EffectCallback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => callbackRef.current(), []);
}
